import React from 'react';
import { Link } from 'react-router-dom';
import { FaEye, FaBullseye, FaRoute } from 'react-icons/fa';
import '../../App.css';
import './Home.css';
import HeroSection from '../HeroSection';
import Cards from '../Cards';
import Footer from '../Footer';
import Slida from '../Slida';
import Locations from '../Locations';

const FOUNDATIONS = [
  {
    icon: <FaEye aria-hidden="true" />,
    title: 'Our Vision',
    body: 'To be a city church influencing our city, our country, our continent, and the whole world in Jesus’ name.',
  },
  {
    icon: <FaBullseye aria-hidden="true" />,
    title: 'Our Mission',
    body: 'To disciple and empower people for transformation in Jesus’ name.',
  },
  {
    icon: <FaRoute aria-hidden="true" />,
    title: 'Our Strategy',
    body: 'To be a place where you come and feel welcome, stay and keep growing, and then go and reach out.',
  },
];

function Home() {
  return (
    <>
      <HeroSection />

      {/* Welcome / values */}
      <section id="welcome" className="tcc-section tcc-section--center home-welcome" aria-labelledby="welcome-heading">
        <div className="tcc-container">
          <p className="tcc-eyebrow" id="welcome-heading">Our vision, mission &amp; strategy</p>

          <ul className="home-values">
            {FOUNDATIONS.map((v) => (
              <li key={v.title} className="tcc-card tcc-card--hover home-value">
                <span className="home-value__icon">{v.icon}</span>
                <h3 className="home-value__title">{v.title}</h3>
                <p className="home-value__body">{v.body}</p>
              </li>
            ))}
          </ul>

          <div className="home-welcome__cta">
            <Link to="/join-mc" className="tcc-btn tcc-btn--primary tcc-btn--lg">
              Plan Your Visit
            </Link>
            <Link to="/about-us" className="tcc-btn tcc-btn--ghost tcc-btn--lg">
              Learn Our Story
            </Link>
          </div>
        </div>
      </section>

      <Cards />
      <Slida />
      <Locations />
      <Footer />
    </>
  );
}

export default Home;
